var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-main"},[_c('home-page'),_c('chat-box')],1)}
var staticRenderFns = []

export { render, staticRenderFns }